import { isNil } from '@flowio/is';
import { DEFAULT_AUTHORIZATION_TIMEOUT_MS, AUTHORIZATION_CALLBACK_MESSAGE_TYPE, CALLBACK_ORIGIN } from '../constants';

function getTimeoutMs(expiresAt) {
  if (expiresAt) {
    var parsedDate = Date.parse(expiresAt);

    if (!Number.isNaN(parsedDate)) {
      var timeoutMs = parsedDate - Date.now();

      if (timeoutMs > 5000) {
        // sanity check, should be at least 5 seconds.
        return timeoutMs;
      }
    }
  }

  return DEFAULT_AUTHORIZATION_TIMEOUT_MS;
}

export default function createInlineCallbackListener() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(function (resolve, reject) {
    var timeoutId = window.setTimeout(function () {
      reject(new Error('@flowio/payment: Payment callback never returned.'));
    }, getTimeoutMs(options.expiresAt)); // eslint-disable-next-line prefer-arrow-callback

    window.addEventListener('message', function messageHandler(event) {
      if (event.origin !== CALLBACK_ORIGIN) {
        return;
      }

      var msg;

      try {
        msg = JSON.parse(event.data);
      } catch (e) {
        reject(new Error("@flowio/payment: Failed to parse callback message. ".concat(msg)));
      }

      if (!isNil(msg) && msg.type === AUTHORIZATION_CALLBACK_MESSAGE_TYPE) {
        if (msg.success) {
          resolve(msg.payload);
        } else {
          reject(msg.payload);
        }

        window.clearTimeout(timeoutId);
        window.removeEventListener('message', messageHandler);
      }
    });
  });
}
//# sourceMappingURL=create-inline-callback-listener.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/utilities/create-inline-callback-listener.js
// module id = 312
// module chunks = 0 1